import * as React from 'react';
import { withRouter, RouteComponentProps } from 'react-router';
import TurnusStore from 'src/stores/TurnusStore';
import ObjednavkaStore from 'src/stores/ObjednavkaStore';
import KlientStore from 'src/stores/KlientStore';
import { inject, observer } from 'mobx-react';
import { Drawer, Grid, AppBar, Toolbar, IconButton, Typography, Paper, TextField, Button, MenuItem, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from '@material-ui/core';
import NavigationDrawerItems from './NavigationDrawerItems';
import { observable, action, computed } from 'mobx';
import MenuIcon from '@material-ui/icons/Menu';
import PreparePaymentDetailsResponse from 'src/services/response/PreparePaymentDetailsResponse';
import SendPaymentDetailsResponse from 'src/services/response/SendPaymentDetailsResponse';
import Klient from 'src/models/Klient';
import Turnus from 'src/models/Turnus';
import NovaObjednavka from "../models/NovaObjednavka";
import AuthStore from "../stores/AuthStore";
import NewOrderResponse from "../services/response/NewOrderResponse";

export interface IOrderNewPreviewProps extends RouteComponentProps<any> {
    klientStore?: KlientStore;
    turnusStore?: TurnusStore;
    authStore?: AuthStore;
    objednavkaStore?: ObjednavkaStore;
    orderTemplate: NovaObjednavka;
}

@inject('klientStore')
@inject('authStore')
@inject('turnusStore')
@inject('objednavkaStore')
@observer
class OrderNewPreview extends React.Component<IOrderNewPreviewProps>{

    // GUI controls
    @observable private isDrawerOpened: boolean = false;
    @observable private isAlertDialogOpened: boolean = false;

    @action
    private drawerMenuClick = event => {
        this.isDrawerOpened = !this.isDrawerOpened;
    }

    private alertDialogClose = event => {
        this.isAlertDialogOpened = false;
    }

    // Data
    @observable private emailText: string = "";
    @observable private emailAddress: string = "adresa@nemam.cz";
    @observable private klienti: Klient[] = [];

    @observable private dataLoaded: boolean = false;

    @computed private get loadStarted(): boolean {
        if(!this.dataLoaded) {
            this.props.objednavkaStore.calculateNewOrderFull(this.props.orderTemplate)
            .then((resp: PreparePaymentDetailsResponse) => {
                this.emailText = resp.emailText;
                this.dataLoaded = true;
            })
        }
        return true;
    }

    private createOrder = (whereTo: string) => () => {
        this.props.objednavkaStore.createNewOrderObject(this.props.orderTemplate)
            .then((retVal: NewOrderResponse) => {
                console.log('Nova objednavka: ' + retVal.objednavka.id);
                this.props.objednavkaStore.objednavky.push(retVal.objednavka);
                this.props.objednavkaStore.removeWebObjednavkaFromLocalStore(this.props.orderTemplate.webObjednavka);
                retVal.turnusy.forEach(trns => {
                    this.props.turnusStore.addTurnus(trns);
                });
                if(whereTo === 'invoice') {
                    this.props.history.push(`/orders/${retVal.objednavka.id}/invoicing`)
                } else if(whereTo === 'paymentDetails') {
                    this.props.history.push(`/paymentDetails/${retVal.objednavka.id}`)
                } else if(whereTo === 'orderDetails') {
                    this.props.history.push(`/orders/${retVal.objednavka.id}`)
                }
            });
    }

    public render() {
        return (
            <div>
            <Drawer open={this.isDrawerOpened} onClose={this.drawerMenuClick}>
                <NavigationDrawerItems />
            </Drawer>
            <Grid container spacing={8}>
                <Grid item xs={12}>
                    <AppBar position="static" >
                        <Toolbar>
                            <IconButton color="inherit" aria-label="Menu" onClick={this.drawerMenuClick}>
                                <MenuIcon />
                            </IconButton>
                            <Typography variant="h6" color="inherit" style={{ flexGrow: 1 }}>
                                Náhled objednávky
                            </Typography>
                            <Button onClick={this.createOrder('orderDetails')} color="inherit">
                                Založit
                            </Button>
                            {this.props.authStore.hasGUIResource('create-invoice') ?
                                <Button onClick={this.createOrder('invoice')} color="inherit">
                                    Na fakturaci
                                </Button> : ''}
                            {this.props.authStore.hasGUIResource('send-payment-details') ?
                                <Button onClick={this.createOrder('paymentDetails')} color="inherit">
                                    Na platební údaje
                                </Button> : ''}
                        </Toolbar>
                    </AppBar>
                </Grid>
                <Grid item xs={12} style={{ margin: 8 }}>
                    {this.loadStarted && this.dataLoaded ? (
                    <Paper style={{ padding: 8 }}>
                        <Grid container item xs={12}>
                            <Grid item xs={12} style={{ margin: 8, paddingTop: 24 }}>
                                <TextField label="Text email" multiline value={this.emailText} fullWidth />
                            </Grid>
                        </Grid>
                    </Paper>
                        ) : ""
                    }
                </Grid>
                </Grid>
                <Dialog
                open={this.isAlertDialogOpened}
                onClose={this.alertDialogClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Asi došlo k chybě"}</DialogTitle>
                <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    Je nám líto, ale někde se stala chyba. Pokud máte trpělivost a touhu měnit svět k lepšímu,
                    nahlaste nám přesný čas události a my se pokusíme problém vyřešit.
                </DialogContentText>
                </DialogContent>
                <DialogActions>
                <Button onClick={this.alertDialogClose} color="primary" autoFocus variant="contained">
                    Budiž
                </Button>
                </DialogActions>
            </Dialog>
            </div>
        )
    }

}

export default withRouter(OrderNewPreview)


// WEBPACK FOOTER //
// ./src/components/OrderNewPreview.tsx